import styled from 'styled-components'

import { Layout, Link, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { useTrackingOnboardingContext } from '../../../TrackingOnboardingContext'
import ImageEDI from '../../assets/tracking-onboarding-finalize-connection-api-edi.png'

const StyledListItem = styled.li`
  padding-bottom: ${getToken('spacing-2')};
  list-style: decimal;
`

export default function EDIFinalizeConnectionContent() {
  const { hasPreviousTracking } = useTrackingOnboardingContext()

  if (hasPreviousTracking) {
    return (
      <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md-bold">EDI integration</Text>
          <Layout.Stack gap="spacing-6">
            <Text variant="body-md">You're about to confirm your preferred connection as EDI.</Text>
            <Text variant="body-md">You can update this choice anytime via the tracking card.</Text>
          </Layout.Stack>
        </Layout.Stack>
        <img src={ImageEDI} alt="" width={285} height={175} />
      </Layout.Group>
    )
  }

  return (
    <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
      <Layout.Stack gap="spacing-4">
        <Text variant="body-md-bold">Let this with our specialists</Text>
        <Text variant="body-md">
          EDI integrations simplifies the exchange of transaction data between shippers and
          carriers.
        </Text>
        <Text variant="body-md">
          To complete this integration, a specialist will assist you through each step. Here's what
          you need to do:
        </Text>
        <Layout.Group paddingL="spacing-4">
          <Text variant="body-md">
            <ol>
              <StyledListItem>
                Identify the shippers you want to integrate and the transaction types required for
                your business
              </StyledListItem>
              <StyledListItem>
                Send an email to
                {
                  <Link href="mailto:solutions@loadsmart.com" aria-label="email link">
                    solutions@loadsmart.com
                  </Link>
                }{' '}
                with the details you collected in step 1, requesting a new EDI integration
              </StyledListItem>
              <StyledListItem>
                After sending your request, a specialist will reach out to guide you through the
                next steps of the EDI integration
              </StyledListItem>
            </ol>
          </Text>
        </Layout.Group>
      </Layout.Stack>
      <img src={ImageEDI} alt="" width={285} height={175} />
    </Layout.Group>
  )
}
